import version from "../../../package.json";
import colors from "../../theme";
import {
  Box,
  Typography,
  Link,
  Container,
  Grid,
  Button,
} from "@mui/material";

const AboutUsPage = () => {
  const legalLinks = [
    {
      text: "Terms & Conditions",
      href: "https://readysteadyplug.com/terms-conditions",
    },
    {
      text: "Privacy Policy",
      href: "https://readysteadyplug.com/privacy-policy",
    },
    {
      text: "Report a Problem",
      href: "https://readysteadyplug.com/site-problem/#report-problem",
    },
    {
      text: "Help & Support",
      href: "https://support.readysteadyplug.com",
    },
  ];
  
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        variant="h4"
        color={colors.primary}
        sx={{ fontWeight: "bold", textAlign: "center" }}
      >
        ReadySteadyPlug
      </Typography>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontWeight: "bold", textAlign: "center" }}
      >
        {process.env.REACT_APP_API_URL.includes("test") ? "Test - " : ""}v{version.version}
      </Typography>  
      <Box
        sx={{
          bgcolor: colors.mainContentBgColor,
          p: 6,
          borderRadius: 1,
          boxShadow: 1,
          textAlign: "center",
          mb: 8,
        }}
      >
        <Grid container spacing={3} justifyContent="center">
          {legalLinks.map((link, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Button
                component={Link}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                fullWidth
                sx={{
                  py: 1,
                  borderRadius: 1,
                  color: "white",
                  bgcolor: colors.secondary,
                  "&:hover": {
                    bgcolor: colors.btnBackgroundColorOnHover,
                    color: "white",
                  },
                }}
              >
                {link.text}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default AboutUsPage;
